export default __webpack_public_path__ + "src/fonts/roboto-slab-v12-latin-100.woff";